import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import PageHeader from '../Header/PageHeader';
import StatsList from './StatsList';
import { stats } from '../../actions/Stats/statsActions';
import PageSpinner from '../../assets/svgs/PageSpinner';

const StatsPage = ({ className }) => {
    const [isFetch, setFetch] = useState(true);

    const dispatch = useDispatch();
    useEffect(() => {
        const getTickets = async () => {
            await dispatch(stats());
            setFetch(false);
        };
        getTickets();
    }, []);

    return (
        <div className={className}>
            <PageHeader title="داده‌های آماری" />
            {!isFetch ? (
                <StatsList />
            ) : (
                <div className="Loading">
                    <PageSpinner />
                </div>
            )}
        </div>
    );
};

export default styled(StatsPage)`
    .Loading {
        display: flex;
        align-items: center;
        justify-content: center;
        height: calc(100vh - 240px);
    }
`;
